import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/components/SwitchProject/SwitchProject.tsx";
var _excluded = ["onToggle", "opened", "projectList", "onClose", "selectedProjectName", "onChangeProject", "disabled", "loading", "renderItem", "badgeIcon", "renderBadgeContent", "size", "noMaxWith"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.map.js";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { ClickAwayListener } from '@mui/material';
import { ProjectBadge } from "./ProjectBadge";
import { SwitchProjectButton, SwitchProjectPopover, SwitchProjectWrapper, ArrowDown, NoItemListText } from "./SwitchProject.styled";
import { SwitchProjectItem } from "./SwitchProjectItem";
import { Folder } from "./ProjectBadge/FolderIcon.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SwitchProject = function SwitchProject(_ref) {
  var onToggle = _ref.onToggle,
      opened = _ref.opened,
      projectList = _ref.projectList,
      onClose = _ref.onClose,
      selectedProjectName = _ref.selectedProjectName,
      onChangeProject = _ref.onChangeProject,
      disabled = _ref.disabled,
      loading = _ref.loading,
      renderItem = _ref.renderItem,
      _ref$badgeIcon = _ref.badgeIcon,
      badgeIcon = _ref$badgeIcon === void 0 ? /*#__PURE__*/_jsx(Folder, {}) : _ref$badgeIcon,
      renderBadgeContent = _ref.renderBadgeContent,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'xl' : _ref$size,
      noMaxWith = _ref.noMaxWith,
      other = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs(SwitchProjectWrapper, _objectSpread(_objectSpread({
    noMaxWith: noMaxWith,
    "data-test-id": "projectSelect"
  }, other), {}, {
    children: [/*#__PURE__*/_jsxs(SwitchProjectButton, {
      active: opened,
      onClick: function onClick(event) {
        event.stopPropagation();
        onToggle();
      },
      disabled: disabled,
      size: size,
      children: [renderBadgeContent ? renderBadgeContent({
        projectName: selectedProjectName,
        icon: badgeIcon,
        loading: loading
      }) : /*#__PURE__*/_jsx(ProjectBadge, {
        icon: badgeIcon,
        projectName: selectedProjectName,
        loading: loading
      }), /*#__PURE__*/_jsx(ArrowDown, {
        color: "#353B60"
      })]
    }), opened && /*#__PURE__*/_jsx(ClickAwayListener, {
      onClickAway: onClose,
      children: /*#__PURE__*/_jsx(SwitchProjectPopover, {
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        children: projectList && (projectList === null || projectList === void 0 ? void 0 : projectList.length) > 0 ? projectList.map(function (project, idx) {
          return renderItem ? renderItem(project, idx) : /*#__PURE__*/_jsx(SwitchProjectItem, {
            onChangeProject: onChangeProject,
            onClose: onClose,
            project: project
          }, project.urn);
        }) : /*#__PURE__*/_jsx(NoItemListText, {
          children: loading ? 'Загрузка...' : 'Нет доступных проектов'
        })
      })
    })]
  }));
};